export default __webpack_public_path__ + "static/media/archi_slider_5.d2834626.webp";